import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { InlineGrid, InlineGridField } from '@components/form';

import { EmployeesFormCertificatesForm } from '@modules/employees/EmployeesFormCertificatesForm';
import { certificatesGridColumns } from '@modules/employees/_employeesColumns';

const View: React.SFC<any> = () => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <h4>Osvědčení</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="certificates"
            Form={EmployeesFormCertificatesForm}
            columns={certificatesGridColumns}
            showCheckboxes={true}
            deleting={true}
          />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const EmployeesFormCertificates = View;



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormCertificates.tsx